var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivitySummaryIconTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 25C1.8125 25 1.22417 24.7554 0.735 24.2662C0.245833 23.7771 0.000833333 23.1883 0 22.5V2.5C0 1.8125 0.245 1.22417 0.735 0.735C1.225 0.245833 1.81333 0.000833333 2.5 0H17.5C18.1875 0 18.7762 0.245 19.2662 0.735C19.7562 1.225 20.0008 1.81333 20 2.5V22.5C20 23.1875 19.7554 23.7762 19.2662 24.2662C18.7771 24.7562 18.1883 25.0008 17.5 25H2.5ZM8.75 11.25L11.875 9.375L15 11.25V2.5H8.75V11.25Z",
    fill: "#00F260"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivitySummaryIconTwo);
export default __webpack_public_path__ + "static/media/activity_summary_icon_two.505ad0182884b2039e845df5eb18dc6c.svg";
export { ForwardRef as ReactComponent };